import React, { useEffect, useState } from 'react';
import FullScreenMessage from './elements/FullScreenMessage';
import { getStatus } from './utils/getStatus';

// Polling interval in seconds
const POLL_INTERVAL = 60 * 5;

const BackendStatusChecker = ({ children }) => {
  const [status, setStatus] = useState(null);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');

  useEffect(() => {
    async function checkStatus() {
      const statusResult = await getStatus();
      // console.log(statusResult);
      if (statusResult?.status) {
        setStatus(prevStatus => statusResult.status);
        setMaintenanceMessage(statusResult.maintenanceMessage);
      }
    }

    checkStatus();
    const interval = setInterval(async () => {
      checkStatus();
    }, 1000 * POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  // console.log({ status, maintenanceMessage });
  if (status === 'maintenance') {
    return <FullScreenMessage message={maintenanceMessage} />;
  }
  return <>{children}</>;
};

export default BackendStatusChecker;
